import { render } from "./tcle_collect.vue?vue&type=template&id=75898642&scoped=true"
import script from "./tcle_collect.vue?vue&type=script&lang=js"
export * from "./tcle_collect.vue?vue&type=script&lang=js"

import "./tcle_collect.vue?vue&type=style&index=0&id=75898642&lang=scss&scoped=true"

import exportComponent from "/Users/felipewalflan/Documents/Gitlab gen-t/_front/base-questionnaire/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75898642"]])

export default __exports__